/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */

/* eslint-disable jsdoc/require-jsdoc */
export const LEGEND_CIRCLE = color => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
  <circle cx="12" cy="12" r="6" stroke="${color}" stroke-width="3" fill-opacity="0" />
  </svg>`;
};
export const LEGEND_DISC = color => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
  <circle cx="12" cy="12" r="6" fill="${color}" />
  </svg>`;
};
export const LEGEND_BOX = color => {
  return `<svg viewport="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
  <rect x="0" y="0" width="24" height="24" stroke="black" fill="${color}" stroke-width="0" />
  </svg>`;
};
export const LEGEND_LINE = dashes => color => {
  return `<svg viewport="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
  <line x1="0" x2="24" y1="12" y2="12" stroke="${color}" stroke-width="2" stroke-linecap="butt" stroke-dasharray="${dashes}"/>
  </svg>`;
};
export const LEGEND_WARNING = color => {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${color}" width="24px" height="24px">
  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
  </svg>
  `;
};
export const LEGEND_ERROR = color => {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${color}" width="24px" height="24px">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"/>
  </svg>
  `;
};
export const LEGEND_OK = color => {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${color}" width="24px" height="24px">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
  </svg>
  `;
};
export const LEGEND_DONTCARE = color => {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${color}" width="18px" height="18px">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
  </svg>
  `;
};
export const LEGEND_NOTHING = () => '';

const _generators = new Map([['circle', LEGEND_CIRCLE], ['disc', LEGEND_DISC], ['box', LEGEND_BOX], ['line', LEGEND_LINE(0)], ['small_dashed_line', LEGEND_LINE(3)], ['large_dashed_line', LEGEND_LINE(5)], ['dotted_line', LEGEND_LINE(2)], ['warning', LEGEND_WARNING], ['error', LEGEND_ERROR], ['ok', LEGEND_OK], ['dontcare', LEGEND_DONTCARE], ['nothing', LEGEND_NOTHING]]);
/**
 * returns a symbol generator for a symbol with the name "name"
 *
 * @param name - name of the generator
 */


export const SYMBOL_GENERATOR = name => {
  return _generators.get(name);
};
/**
 * translates a name to a svg or lets a svg as it is
 *
 * @param nameOrSvg - a name or svg
 * @param color - the color of the symbol
 */

export const TRANSLATE_SYMBOL = (nameOrSvg, color) => {
  return _generators.has(nameOrSvg) ? SYMBOL_GENERATOR(nameOrSvg)(color) : nameOrSvg;
};
/**
 * creates a special generator that returns multiple symbols
 *
 * @param list - a list with names or svg's
 */

export const MULTI_SYMBOL_GENERATOR = list => {
  const size = list.length;
  return (color, index) => {
    const name = list[index % size];
    return TRANSLATE_SYMBOL(name, color);
  };
};
